import React from 'react';

const MANUAL = [
  {
    title: 'The same record, typed three times',
    desc: 'Someone copies a new client from email into the CRM, the accounting tool, and a spreadsheet.',
    waiting: 'Waiting on: whoever has time',
  },
  {
    title: 'Approvals that sit in an inbox',
    desc: 'Requests wait until someone remembers to chase them, and nobody can see where they stand.',
    waiting: 'Waiting on: a reminder email',
  },
  {
    title: 'A new hire costs an afternoon',
    desc: 'Accounts, licenses, folders, and groups get set up by hand, one ticket at a time.',
    waiting: 'Waiting on: the IT queue',
  },
];

const Problem = () => (
  <section className="section" aria-labelledby="problem-heading" data-testid="problem-section">
    <div className="wrap problem-grid">
      <header className="problem-head">
        <h2 id="problem-heading" className="reveal">Still running the business by hand?</h2>
        <p className="lead reveal reveal-1">
          Most teams lose hours every week to admin that software could run on its own.
        </p>
      </header>
      <ul className="manual-list">
        {MANUAL.map((h, i) => (
          <li key={h.title} className={`manual reveal reveal-${i + 1}`}>
            <div className="manual-main">
              <h3>{h.title}</h3>
              <p>{h.desc}</p>
            </div>
            <div className="manual-meta">
              <span className="tag tag-gold">Manual</span>
              <span className="manual-wait">{h.waiting}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Problem;
